import React from "react";

import { IntersectionVideo as Video } from "@brexhq/next/src/components/shared/Video/IntersectionVideo";
import type { StyledVideoProps } from "@brexhq/next/src/components/shared/Video/types";
import { IBynderVideo } from "@brexhq/shared/types/BynderAsset";
import isChromatic from "@brexhq/shared/utils/env/isChromatic";

const getFormatFromUrl = (url: string): string => {
  const urlParts = url.split(".");
  const format = urlParts[urlParts.length - 1];

  return format;
};

const BynderVideo = React.forwardRef<
  HTMLVideoElement,
  IBynderVideo & StyledVideoProps
>(
  (
    { previewImg, previewUrl, captionFile, videoUrl, programName, ...rest },
    ref,
  ) => {
    return (
      <Video
        ref={ref}
        captionFile={captionFile}
        posterImageSrc={previewImg}
        src={videoUrl ?? previewUrl}
        format={getFormatFromUrl(previewUrl || "")}
        programName={programName}
        data-chromatic={isChromatic() ? "ignore" : undefined}
        {...rest}
      />
    );
  },
);
BynderVideo.displayName = "BynderVideo";

export default BynderVideo;
